import { mediaUrl, thumbUrl } from "@/lib/api";

export function Img({ src, alt = "", className = "", sizes = "(max-width: 768px) 100vw, 50vw", eager = false, ...rest }) {
  if (!src) return null;
  const isMedia = src.startsWith("/api/media/");
  return (
    <img
      src={mediaUrl(src)}
      srcSet={isMedia ? `${thumbUrl(src)} 640w, ${mediaUrl(src)} 1600w` : undefined}
      sizes={isMedia ? sizes : undefined}
      alt={alt}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      fetchPriority={eager ? "high" : undefined}
      className={className}
      {...rest}
    />
  );
}

export function RuneMark({ className = "" }) {
  return (
    <svg viewBox="0 0 40 40" className={className} aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M20 3 L35 12 L35 28 L20 37 L5 28 L5 12 Z" />
      <path d="M20 9 V31 M20 15 L28 10 M20 22 L12 17" strokeLinecap="square" />
    </svg>
  );
}

export function SectionLabel({ rune = "ᚱ", index, children, bronze = false }) {
  return (
    <div className="flex items-center gap-3">
      <span className={`font-mono text-xs ${bronze ? "text-[color:var(--bronze)]" : "text-[color:var(--ice)]"}`}>{rune}</span>
      {index && <span className="font-mono text-[11px] text-slate-500">{index}</span>}
      <span className={bronze ? "eyebrow-bronze" : "eyebrow"}>{children}</span>
    </div>
  );
}
